// import _ from 'lodash';
import clsx from 'clsx';
import React from 'react';

import Label from '@/src/components/common/Elements/Label/Label';
import { DEFAULT_EMPTY_LABEL } from '@/src/components/project/Inbox2/Config/inbox.config';
import { getUserWithEmailDisplay } from '@/src/components/project/Inbox2/models/InboxEntry';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { cn } from '@/src/util/ui';

import AccessList from '../../../../Common/InfoPanel/DetailItems/AccessList/AccessList';
import CollapsedList from '../../../../Common/InfoPanel/DetailItems/CollapsedList/CollapsedList';
import FileSize from '../../../../Common/InfoPanel/DetailItems/FileSize/FileSize';
import FormattedDateWithUser from '../../../../Common/InfoPanel/DetailItems/FormattedDateWithUser/FormattedDateWithUser';

type FileDetailsProps = {
  fileEntry: FileEntry;
};

const FileDetails = ({ fileEntry }: FileDetailsProps) => {
  const labelClasses = cn('tw-min-w-[90px]', 'tw-mr-[10px]');
  const mainContainerClasses = cn('tw-mb-[12px]');
  const fromDisplay = getUserWithEmailDisplay(fileEntry.from);

  return (
    <div className={clsx('tabContents--fileDetails', 'tw-px-[20px]')}>
      <Label
        htmlFor={'p-Source'}
        label={'Source'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Source'} className={clsx('tw-text-cfo-black')}>
          {fileEntry.source}
        </p>
      </Label>

      <Label
        htmlFor={'p-From'}
        label={'From'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-From'} className={clsx('tw-text-cfo-black')}>
          {fromDisplay}
        </p>
      </Label>

      <Label
        htmlFor={'p-Created'}
        label={'Created'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Created'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser date={fileEntry.createdDate} userName={fromDisplay} />
        </p>
      </Label>

      <Label
        htmlFor={'p-Opened'}
        label={'Opened'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Opened'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={fileEntry.openedDate}
            userName={fileEntry.openedBy || DEFAULT_EMPTY_LABEL}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Closed'}
        label={'Closed'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Closed'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={fileEntry.closedDate}
            userName={fileEntry.closedBy || DEFAULT_EMPTY_LABEL}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Modified'}
        label={'Modified'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Modified'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={fileEntry.modifiedDate}
            userName={fileEntry.modifiedBy || DEFAULT_EMPTY_LABEL}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Workstreams'}
        label={'Workstreams'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Workstreams'} className={clsx('tw-text-cfo-black')}>
          <CollapsedList
            items={fileEntry.workstreams.map((ws) => ws.name)}
            tooltipKey={'workstreams'}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Tasks'}
        label={'Tasks'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Tasks'} className={clsx('tw-text-cfo-black')}>
          <CollapsedList items={fileEntry.tasks.map((task) => task.name)} tooltipKey={'tasks'} />
        </p>
      </Label>

      <Label
        htmlFor={'p-Location'}
        label={'Location'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Location'} className={clsx('tw-text-cfo-black')}>
          {fileEntry.file.libraryLocation?.path || 'Inbox'}
        </p>
      </Label>

      <Label
        htmlFor={'p-fileSize'}
        label={'File Size'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-fileSize'} className={clsx('tw-text-cfo-black')}>
          <FileSize value={fileEntry.fileSize} />
        </p>
      </Label>

      <Label
        htmlFor={'p-accessList'}
        label={'Access List'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <div id="p-accessList" className={clsx('tw-flex tw-items-center', 'tw-m-0')}>
          <AccessList items={fileEntry.accessList} />
        </div>
      </Label>
    </div>
  );
};

export default FileDetails;
